import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2c761a3f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "splide__track" };
const _hoisted_2 = { class: "splide__list" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "team_carousel__image--overlay" }, null, -1));
const _hoisted_6 = { class: "team_carousel__job-title" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "team_carousel__more-info" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1"
    }, [
        /*#__PURE__*/ _createElementVNode("g", { id: "surface1" }, [
            /*#__PURE__*/ _createElementVNode("path", {
                style: { "fill": "none", "stroke-width": "3", "stroke-linecap": "butt", "stroke-linejoin": "miter", "stroke": "rgb(100%,100%,100%)", "stroke-opacity": "1", "stroke-miterlimit": "4" },
                d: "M 69.190332 35.347461 C 69.190332 54.04043 54.04043 69.190332 35.347461 69.190332 C 16.654492 69.190332 1.497656 54.04043 1.497656 35.347461 C 1.497656 16.654492 16.654492 1.497656 35.347461 1.497656 C 54.04043 1.497656 69.190332 16.654492 69.190332 35.347461 Z M 69.190332 35.347461 ",
                transform: "matrix(0.56338,0,0,0.56338,0,0)"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                style: { "stroke": "none", "fill-rule": "nonzero", "fill": "rgb(100%,100%,100%)", "fill-opacity": "1" },
                d: "M 19.707031 14.558594 C 18.785156 14.558594 17.996094 13.792969 17.996094 12.84375 C 17.996094 11.898438 18.785156 11.132812 19.707031 11.132812 C 20.652344 11.132812 21.421875 11.898438 21.421875 12.84375 C 21.421875 13.792969 20.652344 14.558594 19.707031 14.558594 Z M 18.289062 27.042969 L 18.289062 16.15625 L 21.148438 16.15625 L 21.148438 27.042969 Z M 18.289062 27.042969 "
            })
        ])
    ])
], -1));
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
    key: 0,
    class: "more-info inner"
};
const _hoisted_10 = {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    viewBox: "0 0 377 447",
    width: "377",
    height: "447",
    preserveAspectRatio: "xMidYMid meet",
    style: { "width": "100%", "height": "40px", "transform": "translate3d(0px, 0px, 0px)", "content-visibility": "visible" }
};
const _hoisted_11 = /*#__PURE__*/ _createStaticVNode("<defs data-v-2c761a3f><clipPath id=\"__lottie_element_47\" data-v-2c761a3f><rect width=\"377\" height=\"447\" x=\"0\" y=\"0\" data-v-2c761a3f></rect></clipPath></defs><g clip-path=\"url(#__lottie_element_47)\" data-v-2c761a3f><g transform=\"matrix(0.7071068286895752,0.7071067690849304,-0.7071067690849304,0.7071068286895752,188.39700317382812,223.35400390625)\" opacity=\"1\" style=\"display:block;\" data-v-2c761a3f><g opacity=\"1\" transform=\"matrix(1,0,0,1,0,0)\" data-v-2c761a3f><path fill=\"rgb(255,255,255)\" fill-opacity=\"1\" d=\" M-159.66099548339844,-26.610000610351562 C-159.66099548339844,-26.610000610351562 159.66099548339844,-26.610000610351562 159.66099548339844,-26.610000610351562 C159.66099548339844,-26.610000610351562 159.66099548339844,26.610000610351562 159.66099548339844,26.610000610351562 C159.66099548339844,26.610000610351562 -159.66099548339844,26.610000610351562 -159.66099548339844,26.610000610351562 C-159.66099548339844,26.610000610351562 -159.66099548339844,-26.610000610351562 -159.66099548339844,-26.610000610351562z\" data-v-2c761a3f></path></g></g><g transform=\"matrix(0.7071068286895752,-0.7071067690849304,0.7071067690849304,0.7071068286895752,188.5,223.3979949951172)\" opacity=\"1\" style=\"display:block;\" data-v-2c761a3f><g opacity=\"1\" transform=\"matrix(1,0,0,1,0,0)\" data-v-2c761a3f><path fill=\"rgb(255,255,255)\" fill-opacity=\"1\" d=\" M-159.66099548339844,-26.610000610351562 C-159.66099548339844,-26.610000610351562 159.66099548339844,-26.610000610351562 159.66099548339844,-26.610000610351562 C159.66099548339844,-26.610000610351562 159.66099548339844,26.610000610351562 159.66099548339844,26.610000610351562 C159.66099548339844,26.610000610351562 -159.66099548339844,26.610000610351562 -159.66099548339844,26.610000610351562 C-159.66099548339844,26.610000610351562 -159.66099548339844,-26.610000610351562 -159.66099548339844,-26.610000610351562z\" data-v-2c761a3f></path></g></g></g>", 2);
const _hoisted_13 = [
    _hoisted_11
];
const _hoisted_14 = { class: "more-info__container container" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "more-info__image-container--overlay" }, null, -1));
const _hoisted_16 = { class: "more-info__image-container--job-title" };
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = { class: "more-info__content--wrapper" };
const _hoisted_19 = { class: "more-info__content" };
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = {
    key: 0,
    class: "more-info__content--socials"
};
const _hoisted_23 = ["href"];
const _hoisted_24 = ["href"];
import Splide from '@splidejs/splide';
import { HoverCursor } from 'hover-cursor';
import { onMounted, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'team_carousel',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const team_carousel = ref(null);
        const splider = ref(null);
        const isMoreInfoOpen = ref(false);
        const moreInfoData = ref(null);
        const browserWidth = ref(window.innerWidth);
        let splide = null; // Declare splide variable outside of the event listener
        ;
        onMounted(() => {
            if (isMoreInfoOpen.value) {
                team_carousel.value.style.background = '#313131';
            }
            else {
                team_carousel.value.style.background = props.d.background_colour;
            }
        });
        watch(isMoreInfoOpen, (newValue) => {
            if (team_carousel.value) {
                team_carousel.value.style.background = newValue ? '#313131' : props.d.background_colour;
            }
        }, { immediate: true });
        document.addEventListener('DOMContentLoaded', function () {
            splide = new Splide(splider.value, {
                type: 'loop',
                pagination: false,
                perPage: 1,
                autoWidth: true,
                focus: 'center',
                gap: '6rem',
                drag: true,
                arrows: false,
                autoplay: false
            }).mount();
            // After mounting the Splide, set the initial slide to the center (latest article).
            splide.go('1'); // Move to the previous slide to position the latest article in the center.
            new HoverCursor({
                containerQuery: '.team--slider',
                snapPosition: 'R',
                icon: '/images/explore.svg',
                toggledIcon: '/images/explore.svg',
                customClass: 'cursor'
            });
        });
        // On resizing the browser, close the more info box as this is set height to the browser
        window.addEventListener('resize', function () {
            if (isMoreInfoOpen) {
                if (browserWidth.value != window.innerWidth) {
                    isMoreInfoOpen.value = false;
                }
            }
            browserWidth.value = window.innerWidth;
        });
        function formatName(fullName) {
            return fullName.replace(' ', '<br>');
        }
        function openMoreInfo(person) {
            moreInfoData.value = person;
            isMoreInfoOpen.value = true;
            // Check if viewport width is more than 760px
            if (window.innerWidth > 760) {
                // Get the current height of the team_carousel and set it manually
                const teamCarouselHeight = team_carousel.value ? team_carousel.value.clientHeight : 0;
                team_carousel.value.style.height = `${teamCarouselHeight}px`;
            }
            // Stop autoplay by setting autoplay property to false
            if (splide) {
                splide.options.autoplay = false;
                splide.refresh(); // Refresh the Splide instance to apply the changes
            }
        }
        function closeMoreInfoData() {
            moreInfoData.value = null;
            isMoreInfoOpen.value = false;
            // Remove the inline height style
            team_carousel.value.style.height = '';
            // Resume autoplay by setting autoplay property to true
            if (splide) {
                splide.options.autoplay = true;
                splide.refresh(); // Refresh the Splide instance to apply the changes
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "team_carousel",
                ref_key: "team_carousel",
                ref: team_carousel,
                id: "team"
            }, [
                _createElementVNode("div", {
                    style: _normalizeStyle({ display: isMoreInfoOpen.value ? 'none' : 'block' }),
                    class: "container title"
                }, " Senior Team ", 4),
                _createElementVNode("div", {
                    style: _normalizeStyle({ display: isMoreInfoOpen.value ? 'none' : 'block' }),
                    ref_key: "splider",
                    ref: splider,
                    class: "splide team--slider inner"
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("ul", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.team, (person) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    class: "splide__slide",
                                    onClick: ($event) => (openMoreInfo(person))
                                }, [
                                    _createElementVNode("img", {
                                        src: person.image,
                                        class: "team_carousel__image",
                                        loading: "lazy",
                                        alt: person.title
                                    }, null, 8, _hoisted_4),
                                    _hoisted_5,
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(person.job_title), 1),
                                    _hoisted_7,
                                    _createElementVNode("span", {
                                        class: "team_carousel__title",
                                        innerHTML: formatName(person.title)
                                    }, null, 8, _hoisted_8)
                                ], 8, _hoisted_3));
                            }), 256))
                        ])
                    ])
                ], 4),
                (isMoreInfoOpen.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("span", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (closeMoreInfoData())),
                            class: "more-info__close"
                        }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_13))
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", {
                                class: "more-info__image-container",
                                style: _normalizeStyle({ 'background': 'url(' + moreInfoData.value.image + ')' })
                            }, [
                                _hoisted_15,
                                _createElementVNode("span", _hoisted_16, _toDisplayString(moreInfoData.value.job_title), 1),
                                _createElementVNode("span", {
                                    class: "more-info__image-container--title",
                                    innerHTML: formatName(moreInfoData.value.title)
                                }, null, 8, _hoisted_17)
                            ], 4),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", {
                                        class: "more-info__content--introduction",
                                        innerHTML: moreInfoData.value.introduction
                                    }, null, 8, _hoisted_20),
                                    _createElementVNode("div", {
                                        class: "more-info__content--body",
                                        innerHTML: moreInfoData.value.body
                                    }, null, 8, _hoisted_21)
                                ]),
                                (moreInfoData.value.linkedin_username || moreInfoData.value.instagram_username)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        (moreInfoData.value.linkedin_username)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                href: 'https://www.linkedin.com/in/' + moreInfoData.value.linkedin_username,
                                                class: "main-footer__link"
                                            }, "LinkedIn", 8, _hoisted_23))
                                            : _createCommentVNode("", true),
                                        (moreInfoData.value.instagram_username)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                href: 'https://instagram.com/' + moreInfoData.value.instagram_username,
                                                class: "main-footer__link"
                                            }, "Instagram", 8, _hoisted_24))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 512));
        };
    }
});
